import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// CONSTANTS
export const BASE_URL = "https://dashweb.matrix-erp.sy/";

// ################### MAIN API SLICE ###################
export const apiSlice = createApi({
   baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
   endpoints: (builder) => ({}),
});
